import { Component, OnInit, ElementRef, Output, EventEmitter, HostListener, ChangeDetectorRef, AfterContentInit } from '@angular/core';
import { SearchService } from '../../../services/search.service';
import { WindowRef } from '../../../services/core/window-ref.service';
import { UIDataService } from '../../../../modules/customer-care/services/uidata.service';
import { DataService } from '../../../services/data.service';
import { UIBaseService } from '../../../services/uibase.service';
import { Header } from '../../../models/header.model';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LanguageService } from '../../../services/language-service';
import { environment } from '../../../../../environments/environment';
import WordArray from 'crypto-js/lib-typedarrays';
import Base64 from 'crypto-js/enc-base64';
import SHA256 from 'crypto-js/sha256';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'cop-public-header',
    templateUrl: './public-header.component.html',
    styleUrls: ['./public-header.component.scss'],
    standalone: false
})

export class PublicHeaderComponent implements OnInit, AfterContentInit {

  @Output() codeVerifierEmit: EventEmitter<any> = new EventEmitter();
  @Output() codeChallengeEmit: EventEmitter<any> = new EventEmitter();
  @Output() hideOtherCompsEmit: EventEmitter<boolean> = new EventEmitter();

  RequestedURL = '';
  showMenu: boolean = false;
  filterInput: any;
  header!: Header;
  firstName!: string;
  lastName!: string;
  userType!: string;
  userInfo: any;
  pollingData: any;
  status: boolean = false;
  showDropHide: boolean = false;
  searchResponse: any;
  searchStr: any;
  show: boolean = false;
  publicHeaderlink: any;
  originUrl!: string;
  isAvayaCloudOffice: boolean = false;
  isSearchPage: boolean = false;
  isAvayaCCass: boolean = false;
  infoMenu: boolean = false;
  langDropdown: boolean = false;
  ringSSoSession: any;
  hideListMenus: boolean = false;
  sinInLink: any;
  isSearchOpen: boolean = false;
  isAvayaCloudPrivate: boolean = false;
  CcassPrivateSession: any;
  codeVerifier: string = this.base64URLEncode(WordArray.random(32));
  codeChallenge: string = this.base64URLEncode(this.sha256(this.codeVerifier));
  code_challenge: string | null = window.sessionStorage.getItem("CODE_CHALLENGE");
  code_verifier: string | null = window.sessionStorage.getItem("CODE_VERIFIER");
  userRoles: any; //sometimes array, sometimes string
  localLangCode: string = "";
  isRingSess: boolean = false;
  isCcasSess: boolean = false;
  userState: string = "";
  isMobView: boolean = false;
  viewPage: string = "";
  isAccessDenied: boolean = false;
  leftMenus: any[] = [];
  rightMenus: any[] = [];
  isNoLeftMenus: boolean = false;

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      if(window.innerWidth < 768)
        this.isMobView = true;
      else
        this.isMobView = false;
    }

  constructor(
    private uibase: UIBaseService,
    private ds: DataService,
    private ui: UIDataService,
    private win: WindowRef,
    private el: ElementRef,
    private searchservice: SearchService,
    private languageService: LanguageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.localLangCode = this.languageService.localCode;

    if(window.innerWidth < 768)
      this.isMobView = true;
    else
      this.isMobView = false;

    this.activatedRoute.queryParams.subscribe(query => {
      if(query['view']) {
        this.viewPage = query['view'];
        this.originUrl = window.location.origin + "/customercare" + this.localLangCode + "/public?view=" + this.viewPage;
      } else
        this.originUrl = window.location.origin + "/customercare" + this.localLangCode + "/public";
    });

    let currentUrl: string = window.location.href;

    if (currentUrl.indexOf("search") > -1) {
      this.isSearchPage = true;
    }
    if (currentUrl.indexOf("AvayaCloudOffice") > -1) {
      this.isAvayaCloudOffice = true;
    } else if (currentUrl.indexOf("AvayaCCaaS") > -1 || currentUrl.indexOf("AvayaOneCloudCCaaS") > -1) {
      this.isAvayaCCass = true;
    } else if ((currentUrl.indexOf("AvayaOneCloudPrivate") > -1) || (currentUrl.indexOf("AvayaEnterpriseCloud") > -1) || (currentUrl.indexOf("AvayaAuraPrivateCloud") > -1)) {
      this.isAvayaCloudPrivate = true;
      if (!this.code_challenge || !this.code_verifier) {
        window.sessionStorage.setItem("CODE_VERIFIER", this.codeVerifier);
        window.sessionStorage.setItem("CODE_CHALLENGE", this.codeChallenge);

        this.code_challenge = window.sessionStorage.getItem("CODE_CHALLENGE");
        this.code_verifier = window.sessionStorage.getItem("CODE_VERIFIER");
      }
      this.codeVerifierEmit.emit(this.code_verifier);
      this.codeChallengeEmit.emit(this.code_challenge);
    }

    this.ds.ringSso.subscribe(profile => {
      // console.log("ring profile", profile);
      this.ringSSoSession = profile;
      if (this.ringSSoSession && this.ringSSoSession.emailId) {
        this.isRingSess = true;
      } else
        this.isRingSess = false;

      setTimeout(() => {
        this.updateTabVal(this.isRingSess, []);
      }, 800);
    });

    this.ds.ccassSSO.subscribe((ccassprofile: any) => {
      // console.log("ccass profile", ccassprofile);
      this.CcassPrivateSession = ccassprofile;
      if (this.CcassPrivateSession && this.CcassPrivateSession.email) {
        this.isCcasSess = true;
        // this.userRoles = (ccassprofile && ccassprofile.userRoles) ? ccassprofile.userRoles.map((role: string) => role.toLowerCase()) : [];
        this.userRoles = (ccassprofile && ccassprofile.userRoles) ? ccassprofile.userRoles.flatMap((item: string) => item.toLowerCase().split('|')) : [];
        this.userState = (ccassprofile && ccassprofile.state) ? ccassprofile.state.toLowerCase() : null;
      } else {
        this.isCcasSess = false;
        this.userRoles = [];
        this.userState = "";
      }

      setTimeout(() => {
        this.updateTabVal(this.isCcasSess, this.userRoles);
      }, 800);
    });

    this.filterInput = this.ui;
    this.publicHeaderlink = this.filterInput.uibase.pageHeader.headerLinks;
    if(this.publicHeaderlink && this.publicHeaderlink.length) {
      this.publicHeaderlink.forEach((element: any) => {
        if(element.HasSubHeaderLink && element.HasSubHeaderLink === "true")
          element.HasSubHeaderLink = true;
        else
          element.HasSubHeaderLink = false;

        if (element.alttext === "signin") {
          let singinUrl = "";
          if (this.isAvayaCloudPrivate) {
            if (element.HasSubHeaderLink) {
              element.SubHeaderLinks.forEach((subLinks: any) => {
                subLinks.url = subLinks.url + "&code_challenge=" + this.code_challenge;
              });
            } else {
              singinUrl = element.url + "&code_challenge=" + this.code_challenge;
              element.url = singinUrl;
            }
            this.ui.signInShare.next(singinUrl);
          }
          this.sinInLink = element;
        }

        if(element.alttext === "language") {
          (element.SubHeaderLinks && element.SubHeaderLinks.length) && element.SubHeaderLinks.forEach((link: any) => {
            link["isSelectedLang"] = false;

            if(this.localLangCode.includes("en") && (link.alttext === "English"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("de") && (link.alttext === "Deutsch"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("nl") && (link.alttext === "Dutch"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("fr") && ((link.alttext === "French") || (link.alttext === "Français")))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("it") && (link.alttext === "Italian"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("es") && (link.alttext === "Espanol"))
              link.isSelectedLang = true;
            else
              link.isSelectedLang = false;
          });
        }
      });

      const separatorIdx = this.publicHeaderlink.findIndex((obj: any) => obj.alttext === "Header-Separator");
      this.leftMenus = this.publicHeaderlink.slice(0, separatorIdx);
      this.isNoLeftMenus = (this.leftMenus.length === 0);
      this.rightMenus = this.publicHeaderlink.slice(separatorIdx + 1);
      this.rightMenus.sort((a: any, b: any) => (a.alttext === 'signin' ? 1 : b.alttext === 'signin' ? -1 : 0)); // just to shift signin object at end of an array
    }

    // console.log("leftMenus", this.leftMenus);
    // console.log("rightMenus", this.rightMenus);

    this.userInfo = this.uibase.userInfo;
    this.userType = this.uibase.userInfo.usertype;

    // let ssoUserProfile = window.localStorage.getItem("ssoUser");
    // if (ssoUserProfile) {
    //   try {
    //     let profile = JSON.parse(ssoUserProfile);
    //     this.userRoles = profile.value && profile.value.userRoles ? profile.value.userRoles.map((role: string) => role.toLowerCase()) : [];
    //     this.userState = profile.value && profile.value.state ? profile.value.state.toLowerCase() : null;
    //   } catch (e) {
    //     console.error("Error while parsing sso user object", e);
    //   }
    // }
  }

  clickEvent() {
    this.status = !this.status;
  }

  closeMenuItems() {
    let dropdowns = this.el.nativeElement.querySelectorAll(".menu-dropdown,.menuList,.user-dropdown");
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].classList.remove('open');
      let arrowIcons = dropdowns[i].querySelectorAll('.rotate,.active')
      arrowIcons.forEach((icon: any) => {
        icon.classList.remove('rotate');
        icon.classList.remove('active');
      });
      dropdowns[i].classList.remove('active');
    }
  }

  openLanguageDropdown() {
    this.langDropdown = true;
  }

  closeLanguageDropdown() {
    this.langDropdown = false;
  }

  linkTarget(link: any, targetType: string) {
    if (!link.HasSubHeaderLink) {
      window.open(link.url, targetType);
    }
  }

  onLoginEventFired(event: any, searchStr: any) {
    this.showDropHide = true;
    let autoFillUrl = '/cs/Satellite?pagename=OCP/Search/getSuggestions&q=' + searchStr + '&client=test_frontend&site=default_collection&format=os';
    this.ds.getSearchResults(autoFillUrl)
      .pipe(
        catchError(val => of(`ERROR sending data ${val}`))
      )
      .subscribe(resp => {
        this.searchResponse = resp;
      });

    if ((event.key == 'Enter' || event.which === 1)) {
      this.show = !this.show;
      this.searchservice.setSearchTerm(searchStr);
      this.searchservice.setSearchResultsPageStatus(false);
      this.searchStr = '';
    }
  }

  headSearch() {
    this.show = !this.show;
    this.showDropHide = false;
  }

  revokeSsoSesion() {
    const url = "revokeToken";
    const formData = new FormData();
    formData.append("Token", this.ringSSoSession.accessToken);

    this.ds.getITSSToken().subscribe((res: any) => {
      if(res && res.token) {
        this.ds.publicPostData(url, formData, res.token)
          .pipe(
            switchMap((resp: any) => {
              return of(resp);
            }))
          .subscribe(data => {
            this.ds.getRingSessionData(null);
            window.localStorage.removeItem('ringUser');
            window.localStorage.clear();
            window.sessionStorage.clear();
            window.open(window.location.origin + "/customercare" + this.localLangCode + "/public?view=" + this.viewPage, "_self");
          });
      } else {
        console.error("Itss token fetch failed", res);
      }
    });
  }

  revokeAOCSession() {
    window.localStorage.removeItem('ssoUser');
    window.localStorage.clear();
    window.sessionStorage.clear();

    if (window.location.href.indexOf("AvayaOneCloudPrivate") > -1)
      window.location.href = environment.pci_signout + "AvayaEnterpriseCloud";
    else if (window.location.href.indexOf("AvayaEnterpriseCloud") > -1) {
      if(this.userState === 'aim')
        window.location.href = environment.pci_signout_aim + "AvayaEnterpriseCloud";
      else
        window.location.href = environment.pci_signout_aec + "AvayaEnterpriseCloud";
    } else if((window.location.href.indexOf("AvayaAuraPrivateCloud") > -1)) {
      if(this.userState === 'aim')
        window.location.href = environment.pci_signout_aim + "AvayaAuraPrivateCloud";
      else
        window.location.href = environment.pci_signout_aec + "AvayaAuraPrivateCloud";
    }
  }

  OpenRequestsView(type: string) {
    this.isSearchOpen = true;
    if(this.isMobView)
      this.showMenu = !this.showMenu;
    this.ui.openRequestsTab.next(type);
    this.ui.openSearchView.next(false);
    this.hideOtherCompsEmit.emit(true);

    if (type == 'my') {
      this.RequestedURL = window.location.href + this.localLangCode + "/public/myrequests?view=" + this.viewPage;
      this.router.navigateByUrl(this.localLangCode + "/public/myrequests?view=" + this.viewPage);
    } else if (type == 'history') {
      this.RequestedURL = window.location.href + this.localLangCode + "/public/history?view=" + this.viewPage;
      this.router.navigateByUrl(this.localLangCode + "/public/history?view=" + this.viewPage);
    } else if (type == 'mycompanysr') {
      this.RequestedURL = window.location.href + this.localLangCode + "/public/mycomprequests?view=" + this.viewPage;
      this.router.navigateByUrl(this.localLangCode + "/public/mycomprequests?view=" + this.viewPage);
    }

    setTimeout(() => {
      // let myWindow = window as any;
      // myWindow.sendObjectToChatBot({ hosting_url: this.RequestedURL })
      this.closeProfileDropdown();
      this.closeMenuItems();
    }, 1000);
  }

  closeProfileDropdown() {
    let dropdowns = this.el.nativeElement.querySelectorAll(".cop-prof");
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].classList.remove('open');
      dropdowns[i].classList.remove('active');
    }
  }

  openSearchView() {
    this.isSearchOpen = false;
    if(this.isMobView)
      this.showMenu = !this.showMenu;
    this.ui.openSearchView.next(true);
    this.ui.openRequestsTab.next("");
    this.hideOtherCompsEmit.emit(false);
    this.router.navigateByUrl(this.localLangCode + "/public?view="+ this.viewPage);
  }

  base64URLEncode(str: any) {
    return str.toString(Base64)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  sha256(buffer: any) {
    return SHA256(buffer);
  }

  ngOnDestroy() {
    this.pollingData.unsubscribe();
  }

  updateTabVal(isSession: boolean, userRoles?: any[]) {
    let currentUrl = window.location.href;

    if(isSession) {
      if(currentUrl.indexOf('/public/myrequests?view=') > -1 || currentUrl.indexOf('/public/history?view=') > -1) {
        this.isSearchOpen = true;
        this.ui.openSearchView.next(false);
        this.hideOtherCompsEmit.emit(true);

        if(currentUrl.indexOf('/public/myrequests?view=') > -1)
          this.ui.openRequestsTab.next("my");
        else if(currentUrl.indexOf('/public/history?view=') > -1)
          this.ui.openRequestsTab.next("history");
      } else if(currentUrl.indexOf('/public/mycomprequests?view=') > -1) {
        if(userRoles && userRoles.length && (userRoles.includes('admin') || userRoles.includes('onecareticketadmin'))) {
          this.isAccessDenied = false;
          this.isSearchOpen = true;
          this.ui.openSearchView.next(false);
          this.hideOtherCompsEmit.emit(true);
          this.ui.openRequestsTab.next("mycompanysr");
        } else {
          this.isAccessDenied = true;
          this.isSearchOpen = false;
          this.ui.openSearchView.next(true);
          this.hideOtherCompsEmit.emit(false);
          this.ui.openRequestsTab.next("");
          this.router.navigateByUrl(this.localLangCode + '/public?view=' + this.viewPage);
        }
      } else {
        this.isSearchOpen = false;
        this.ui.openSearchView.next(true);
        this.hideOtherCompsEmit.emit(false);
        this.ui.openRequestsTab.next("");
      }
    } else {
      this.isSearchOpen = false;
      this.ui.openSearchView.next(true);
      this.hideOtherCompsEmit.emit(false);
      this.ui.openRequestsTab.next("");
    }
  }

  ngAfterContentInit() {
    this.cdref.detectChanges();
  }
}
